module.exports = __webpack_public_path__ + "img/hwc_img3.37291ab2.jpg";